import { render, staticRenderFns } from "./BuildStorage.vue?vue&type=template&id=1cc6a468&scoped=true&"
import script from "./BuildStorage.vue?vue&type=script&lang=ts&"
export * from "./BuildStorage.vue?vue&type=script&lang=ts&"
import style0 from "./BuildStorage.vue?vue&type=style&index=0&id=1cc6a468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6a468",
  null
  
)

export default component.exports